import { api } from '.'

export async function claimUserTodayCalendarRewardFn(): Promise<any> {
  const { data } = await api.post<any>('/rewards/claim/today')

  return data
}
